var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* 06/25/2020 - Christian Maldonado

    Purpose:
	This class will determine which theme styling and request parameters to use depending on the theme.

    Backgroud:
    Pages that include this general rate-quote module need to pass the lead source of the page as we will
    use it to determine which files we will use to customize the component for that page in particular.
    Example: https://swmc-landingpages.s3.amazonaws.com/rate-quotes?leadSource=TEXAS-TV

    Requirements for a theme (this is subject to change based on the best implementation that satisfies our needs):
    1. Lead source -> Each theme will be determined by the lead source (this can be changed to some other parameter). The parameter will be
                      added in the switch case inside function loadThemeParams().
    2. A class/module that extends Component -> Each theme should have a class/module that can make the necessary imports and return the
                       parameters needed in the page. See src/modules/themes/LowRates.js as an example.
    3. Request Rates JSON files (optional) -> json files that deterine parameters that the pricing engine needs.
                       See src/modules/themes/includes/requestRatesNoCC_LOWRATES.json for an example.
    4. CSS file (optional) -> A styling sheet (css) that can override the colors and properties of elements in the page.
                       See /src/modules/themes/css/lowratestv.css for an example.

    Current limitations:
        - Right now when the page loads it does the imports of LowRates and LowRatesTV and automatically does the imports for the
          css files of each one. You can see it in the inspect element of the top banner of the page. You'll see that for #topBanner
          there are 2 or 3 entries. We need to find a solution so that it only loads the default css and the css of the theme that
          will be applied.

    Work to do:
        - Need to allow customization of important components in the page like the buttons that we show for each loan program (FHA, VA, etc.)
          Example: LowRates.tv only shows Conventional, FHA and VA but LowRates.com shows those plus USDA. Therefore, the sections should be
          customizable for that too.
        - Ask Dennis for more details on what more needs to be customizable.
*/
import { Component } from "react";
import LowRatesTV from "./themes/LowRatesTV";
import LowRatesInBoundNoNPC from "./themes/LowRatesInBoundNoNPC";
import BankRateCom from "./themes/BankRateCom";
import CreditKarma from "./themes/CreditKarma";
import AutismHeroes from "./themes/AutismHeroes";
import CapitalHomeMortgage from "./themes/CapitalHomeMortgage";
import FLWNET049 from "./themes/FLWNET049";
import defaultRates from "./themes/includes/requestRates_DEFAULT.json";

var ThemeConfig = function (_Component) {
    _inherits(ThemeConfig, _Component);

    function ThemeConfig(props) {
        _classCallCheck(this, ThemeConfig);

        var _this = _possibleConstructorReturn(this, (ThemeConfig.__proto__ || Object.getPrototypeOf(ThemeConfig)).call(this, props));

        _this.loadThemeParams(props.leadSource);
        return _this;
    }

    _createClass(ThemeConfig, [{
        key: "loadThemeParams",
        value: function loadThemeParams(leadSource) {
            switch (leadSource) {
                case "TEXAS-TV":
                    var lrtv = new LowRatesTV();
                    this.requestRates = lrtv.getRequestRates();
                    this.isNoCCProgram = lrtv.isNoCCProgram;
                    this.isLowPaymentProgram = lrtv.isLowPaymentProgram;
                    this.domain = "lowrates.tv";
                    break;
                case "NET049":
                    var flw = new FLWNET049();
                    this.requestRates = flw.getRequestRates();
                    this.isNoCCProgram = flw.isNoCCProgram;
                    this.isLowPaymentProgram = flw.isLowPaymentProgram;
                    this.domain = "frontlinewarriors.swmc.com";
                    break;
                case "BANKRATE.COM":
                    var bankr = new BankRateCom();
                    this.requestRates = bankr.getRequestRates();
                    this.isNoCCProgram = bankr.isNoCCProgram;
                    this.isLowPaymentProgram = bankr.isLowPaymentProgram;
                    this.domain = "lowrates.com";
                    break;
                case "CREDKARMA":
                    var ck = new CreditKarma();
                    this.requestRates = ck.getRequestRates();
                    this.isNoCCProgram = ck.isNoCCProgram;
                    this.isLowPaymentProgram = ck.isLowPaymentProgram;
                    this.domain = "swmc.com";
                    break;
                case "INBOUNDNONPC":
                    var ah = new AutismHeroes();
                    this.requestRates = ah.getRequestRates();
                    this.isNoCCProgram = ah.isNoCCProgram;
                    this.isLowPaymentProgram = ah.isLowPaymentProgram;
                    this.domain = "swmc.com";
                    break;
                case "BLCHMWEB":
                    var chm = new CapitalHomeMortgage();
                    this.requestRates = chm.getRequestRates();
                    this.isNoCCProgram = chm.isNoCCProgram;
                    this.isLowPaymentProgram = chm.isLowPaymentProgram;
                    this.domain = "capitalhomemortgage.com";
                    break;
                default:
                    this.requestRates = defaultRates;
                    this.isNoCCProgram = false;
                    this.isLowPaymentProgram = true;
                    break;
            }
        }
    }]);

    return ThemeConfig;
}(Component);

export default ThemeConfig;